import script from "./EPopper.vue?vue&type=script&lang=ts&setup=true"
export * from "./EPopper.vue?vue&type=script&lang=ts&setup=true"

import "./EPopper.vue?vue&type=style&index=0&id=274527be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274527be"]])

export default __exports__